<filter-container [filters]="filters" [dataStream]="getDataStream()" (filteredDataChange)="filteredDataChanged($event)" ></filter-container>

<base-table [config]="config" [dataStream]="data$" [pushData]="false"></base-table>